import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setCurrentStep, setsteps } from './Stepper/stepperSlice';
import { useGetJobCardByReferenceQuery } from '../api/apiSlice';

export const useStepperStateRestoration = () => {
  const dispatch = useDispatch();
  const { job_card_reference_id } = useParams();
  const { data: job_card_data, isSuccess: isGetJobCardStateSuccess } = useGetJobCardByReferenceQuery(
    job_card_reference_id,
    { skip: !job_card_reference_id }
  );
  const lastKeyRef = useRef(null);

  useEffect(() => {
    if (isGetJobCardStateSuccess && job_card_data) {
      const key = `${job_card_data.install_state}-${job_card_data.state}`;
      if (lastKeyRef.current === key) return;
      lastKeyRef.current = key;
      // Set the appropriate steps array and current step based on install state and state
      // Logic copied directly from InstallerLandingPage.js
      if (job_card_data.install_state === "NEW") {
        dispatch(setsteps([0, 1, 2, 3, 4, 5]));

        if (job_card_data.state === "QRC") {
          dispatch(setCurrentStep(1));
        } else if (job_card_data.state === "BEFWA" || job_card_data.state === "BEF") {
          dispatch(setCurrentStep(2)); // BEF is compat for jobs paused mid-old-flow
        } else if (job_card_data.state === "AMP") {
          dispatch(setCurrentStep(3));
        } else if (job_card_data.state === "TES") {
          dispatch(setCurrentStep(4));
        } else if (job_card_data.state === "AFT" || job_card_data.state === "AFTWA") {
          dispatch(setCurrentStep(5)); // AFTWA is compat for jobs paused mid-old-flow
        }
      } else if (job_card_data.install_state === "UN") {
        dispatch(setsteps([0, 1, 2, 3]));

        if (job_card_data.state === "BEFWA" || job_card_data.state === "BEF") {
          dispatch(setCurrentStep(1)); // BEF is compat
        } else if (job_card_data.state === "UNI") {
          dispatch(setCurrentStep(2));
        } else if (job_card_data.state === "AFT" || job_card_data.state === "AFTWA") {
          dispatch(setCurrentStep(3)); // AFTWA is compat
        } else {
          dispatch(setCurrentStep(0));
        }
      } else if (job_card_data.install_state === "RE") {
        dispatch(setsteps([0, 1, 2, 3, 4, 5, 6, 7]));

        if (job_card_data.state === "BEFWA" || job_card_data.state === "BEF") {
          dispatch(setCurrentStep(1)); // BEF is compat
        } else if (job_card_data.state === "UNI") {
          dispatch(setCurrentStep(2));
        } else if (job_card_data.state === "QRCRE") {
          dispatch(setCurrentStep(3));
        } else if (job_card_data.state === "DET") {
          dispatch(setCurrentStep(4));
        } else if (job_card_data.state === "AMP") {
          dispatch(setCurrentStep(5));
        } else if (job_card_data.state === "TES") {
          dispatch(setCurrentStep(6));
        } else if (job_card_data.state === "AFT" || job_card_data.state === "AFTWA") {
          dispatch(setCurrentStep(7)); // AFTWA is compat
        } else {
          dispatch(setCurrentStep(0));
        }
      }
    }
  }, [isGetJobCardStateSuccess, job_card_data, dispatch]);

  return {
    job_card_data,
    isJobCardStateLoaded: isGetJobCardStateSuccess
  };
};